import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const ProcurementPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default ProcurementPageLayout;